// Eye-Able Footer Button Controller - Simple Version
class EyeAbleFooterButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.isOpen = false;
    this.init();
  }

  init() {
    console.log('[Eye-Able] Initializing...');
    
    // Wait for Eye-Able to be loaded
    this.waitForEyeAble();
    
    // Add click event to footer button
    if (this.button) {
      this.button.addEventListener('click', this.toggleEyeAble.bind(this));
    }
  }

  waitForEyeAble() {
    const checkInterval = setInterval(() => {
      const eyeAbleContainer = document.querySelector('.eyeAble_container_b');
      
      if (eyeAbleContainer) {
        clearInterval(checkInterval);
        console.log('[Eye-Able] Container found!');
        this.setupEyeAble();
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  }

  setupEyeAble() {
    const eyeAbleContainer = document.querySelector('.eyeAble_container_b');
    
    if (eyeAbleContainer) {
      // Hide container by default
      eyeAbleContainer.style.display = 'none';
      console.log('[Eye-Able] Container hidden by default');
    }
  }

  toggleEyeAble() {
    const eyeAbleContainer = document.querySelector('.eyeAble_container_b');
    
    if (!eyeAbleContainer) {
      console.log('[Eye-Able] ERROR: Container not found!');
      return;
    }
    
    // Simple toggle: if hidden, show it; if visible, hide it
    if (eyeAbleContainer.style.display === 'none') {
      console.log('[Eye-Able] Opening widget (display: block)');
      eyeAbleContainer.style.display = 'block';
      this.isOpen = true;
    } else {
      console.log('[Eye-Able] Closing widget (display: none)');
      eyeAbleContainer.style.display = 'none';
      this.isOpen = false;
    }
  }
}

// Register the custom element
customElements.define('eyeable-footer-button', EyeAbleFooterButton);